import { useMemo } from 'react'
import { personName } from 'Data/format.js'

let TIME_INTERVALS = ['0-30', '31-60', '61-90', '90-120', '> 120']

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data
      .map(entry => {
        let dues = [
          entry.due_now - entry.due_30_days,
          entry.due_30_days - entry.due_60_days,
          entry.due_60_days - entry.due_90_days,
          entry.due_90_days - entry.due_120_days,
          entry.due_120_days,
        ]

        let paymentAccountName = getPaymentAccountName(entry.payment_account)

        return dues
          .map((due, index) => ({
            id: `${entry.id}-${index}`,
            name: paymentAccountName,
            due,
            time_interval: TIME_INTERVALS[index],
          }))
          .filter(({ due }) => due > 0)
          .flat()
      })
      .flat()
  }, [data])
}

function getPaymentAccountName(payment_account) {
  if (payment_account === null) return null

  let collection_label =
    payment_account.collection_labels?.[0]?.collection_label_template?.name

  switch (payment_account.account_type) {
    case 'PersonPaymentAccount':
      return collection_label
        ? `${personName(
            payment_account.person_payment_account.payer_person
          )} (${collection_label})`
        : personName(payment_account.person_payment_account.payer_person)
    case 'InsurancePaymentAccount':
      return collection_label
        ? `${payment_account.insurance_payment_accounts[0].insurance_company.carrier_name} (${collection_label})`
        : payment_account.insurance_payment_accounts[0].insurance_company
            .carrier_name
    default:
      return null
  }
}
